import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { HeroUIProvider } from "@heroui/react";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <HeroUIProvider>
                <App />
            </HeroUIProvider>
        </HelmetProvider>
    </React.StrictMode>
);
